// node modules
import React from 'react';
import { AbstractItemList } from 'searchkit';
import Menu, { MenuItem } from 'rc-menu';

class SearchkitMenu extends AbstractItemList {
  constructor(props) {
    super(props);

    this.bound = {
      handleClick: this.handleClick.bind(this),
    };
  }

  handleClick(option) {
    const { setItems } = this.props;
    setItems([option.key]);
  }

  render() {
    const { items = [], selectedItems } = this.props;

    const actions = items.map(option => (
      <MenuItem key={option.key} onClick={() => this.bound.handleClick(option)}>
        {option.label}
      </MenuItem>
    ));

    return (
      <Menu selectable={false} selectedKeys={selectedItems}>
        {actions}
      </Menu>
    );
  }
}

export default SearchkitMenu;
